import React from 'react';
import { MapPin, Mail, Phone, Clock, Building2, Send, ExternalLink, Sparkles } from 'lucide-react';

const Contactos = () => {
    const contactInfo = [
        {
            icon: <MapPin className="w-5 h-5" />,
            title: "Endereço",
            content: "Av. Julius Nyerere, 3453",
            subcontent: "Maputo, Moçambique",
            link: null
        },
        {
            icon: <Mail className="w-5 h-5" />,
            title: "E-mail",
            content: "alumni@uem.ac.mz",
            subcontent: null,
            link: "mailto:alumni@uem.ac.mz"
        },
        {
            icon: <Phone className="w-5 h-5" />,
            title: "Telefone",
            content: "+258 21 491 011",
            subcontent: null,
            link: "tel:+25821491011"
        }
    ];

    const schedule = [
        { days: "Segunda a Sexta-feira", hours: "7:30 - 15:30" },
        { days: "Sábado e Domingo", hours: "Fechado" }
    ];

    return (
        <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
            {/* Header Section */}
            <div className="mb-12">
                <div className="border-l-4 border-emerald-500 pl-4 mb-4">
                    <h1 className="text-3xl font-light text-gray-800 tracking-tight">Contactos</h1>
                    <p className="text-gray-500 text-base font-light mt-1">
                        Fale connosco para esclarecimento de dúvidas ou informações
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Contact Information Panel */}
                <div className="space-y-5">
                    {/* Main Card */}
                    <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                        <div className="p-6 border-b border-gray-50">
                            <div className="flex items-center gap-2 mb-1">
                                <Building2 className="w-5 h-5 text-emerald-500" />
                                <h2 className="text-lg font-medium text-gray-800">Direcção do Registo Académico</h2>
                            </div>
                            <p className="text-sm text-gray-500 ml-7">Campus Universitário Principal</p>
                        </div>

                        <div className="divide-y divide-gray-50">
                            {contactInfo.map((item, index) => (
                                <div key={index} className="p-5 hover:bg-gray-50/50 transition-colors">
                                    <div className="flex items-start gap-4">
                                        <div className="text-emerald-500 mt-0.5">
                                            {item.icon}
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">
                                                {item.title}
                                            </h3>
                                            {item.link ? (
                                                <a 
                                                    href={item.link}
                                                    className="text-base text-gray-800 hover:text-emerald-600 transition-colors inline-flex items-center gap-1"
                                                >
                                                    {item.content}
                                                    <ExternalLink className="w-3 h-3" />
                                                </a>
                                            ) : (
                                                <>
                                                    <p className="text-base text-gray-800">{item.content}</p>
                                                    {item.subcontent && (
                                                        <p className="text-sm text-gray-500 mt-0.5">{item.subcontent}</p>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Schedule Section */}
                            <div className="p-5">
                                <div className="flex items-start gap-4">
                                    <div className="text-emerald-500 mt-0.5">
                                        <Clock className="w-5 h-5" />
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-2">
                                            Horário de Funcionamento
                                        </h3>
                                        <div className="space-y-1.5">
                                            {schedule.map((item, idx) => (
                                                <div key={idx} className="flex justify-between items-center text-sm">
                                                    <span className="text-gray-600">{item.days}</span>
                                                    <span className="text-gray-800 font-medium">{item.hours}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Response Card */}
                    <div className="bg-gradient-to-r from-emerald-50/50 to-transparent rounded-xl p-5 border border-emerald-100/50">
                        <div className="flex items-start gap-3">
                            <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                                <Sparkles className="w-4 h-4 text-emerald-600" />
                            </div>
                            <div>
                                <h3 className="text-sm font-medium text-gray-700 mb-1">Resposta Rápida</h3>
                                <p className="text-xs text-gray-500 leading-relaxed">
                                    Normalmente respondemos a emails em até 24 horas úteis. 
                                    Para assuntos urgentes, ligue durante o horário de funcionamento.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Map Panel */}
                <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                    <div className="relative h-full min-h-[450px]">
                        <iframe
                            title="Localização UEM"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3585.8799247726446!2d32.60274667536755!3d-25.95161997751799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ee79c3e435517c5%3A0x1f66cd2b7c551686!2sUniversidade%20Eduardo%20Mondlane!5e0!3m2!1spt-PT!2smz!4v1700565144600!5m2!1spt-PT!2smz"
                            width="100%"
                            height="100%"
                            style={{ border: 0, minHeight: '450px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            className="rounded-xl"
                        />
                    </div>
                    <div className="p-4 border-t border-gray-50 bg-gray-50/30">
                        <div className="flex items-center justify-between">
                            <span className="text-xs text-gray-500">Universidade Eduardo Mondlane</span>
                            <a 
                                href="https://maps.google.com/?q=Universidade+Eduardo+Mondlane"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs text-emerald-600 hover:text-emerald-700 flex items-center gap-1"
                            >
                                Ver no mapa
                                <ExternalLink className="w-3 h-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    );
};

export default Contactos;